import { DateTime } from "luxon";

// Opening-hours fix "Push start to <opening time>": keeps the end time while
// the visit still fits before it; when the place opens at or after the
// event's end, the end moves too, keeping the visit's length. Moving only
// the start turned a 08:00–09:00 museum visit into "10:00 – 09:00"
// (2026-10-24). Identical in andiamo-web and andiamo-places.
export const pushStartTimes = (event, minutesUntilOpen) => {
  const start = DateTime.fromISO(event.Start, { zone: "utc" });
  const end = DateTime.fromISO(event.End, { zone: "utc" });
  const newStart = start.plus({ minutes: minutesUntilOpen });
  const keepsEnd = newStart < end;
  return { Start: newStart.toISO(), End: keepsEnd ? end.toISO() : end.plus({ minutes: minutesUntilOpen }).toISO(), keepsEnd };
};
